import { IModalConfirmRef } from 'components/Modal/ModalConfirm';
import { CALENDAR_VIEW_TYPE } from 'features/appointment/services/constants';
import appointmentSelectors from 'features/appointment/services/selectors';
import {
  ICalendarHeader,
  ICalendarItemData,
  ICalendarSchema,
} from 'features/appointment/services/types/calendar';
import { IDateRangeItem } from 'features/appointment/utils/getRangeDates';
import { getFullDayOffStaffIds, IStaffWorkingHours } from 'features/appointment/utils/get-full-day-off-staff-ids';
import { sortStaffOffToEnd } from 'features/appointment/utils/sort-staff-off-to-end';
import moment from 'moment';
import React, { useCallback, useMemo } from 'react';
import shopSelectors from 'services/shop/selectors';
import { momentTimezone } from 'utils/time';
// const ButtonAddMinus = styled.button`
//   display: flex;
//   width: 40px;
//   height: 40px;
//   justify-content: center;
//   align-items: center;
//   gap: 10px;
//   position: absolute;
//   right: 6.333px;
//   border-radius: 4px;
//   background: #e4f4f6;
//   img {
//     width: 32px;
//     height: 32px;
//   }

//   &:hover,
//   &:active {
//     background: #eee;
//   }
// `;

export const modalConfirmRef = React.createRef<IModalConfirmRef>();
type Props = {
  modal?: boolean;
};
const useCalendarFilter = ({ modal }: Props): ICalendarSchema => {
  const distanceTimeline = appointmentSelectors.getDistanceTimeline();
  const typeView = appointmentSelectors.getViewType();
  const dateRangeList = appointmentSelectors.getDateRangeList();
  const staffListStore = appointmentSelectors.getListStaffAvailableBooking();
  // const staffPage = appointmentSelectors.getStaffPage();
  const staffLimit = appointmentSelectors.getStaffLimit();
  const staffFilter = appointmentSelectors.staffFilter();
  const allSetting = shopSelectors.data.allSetting();
  const lockBreakTimes = appointmentSelectors.getLockBreakTimes();
  const allStaffLoaded = appointmentSelectors.getAllStaffLoaded();

  // Giờ làm việc theo từng staff — dùng để xác định block nào phủ kín cả ngày.
  const workingHoursByStaff = useMemo(() => {
    const map = new Map<string, IStaffWorkingHours>();
    staffListStore.forEach((s) => {
      if (s.timeSchedule?.startTime && s.timeSchedule?.endTime) {
        map.set(s.id, s.timeSchedule);
      }
    });
    return map;
  }, [staffListStore]);

  const offStaffIds = useMemo(
    () => getFullDayOffStaffIds(lockBreakTimes, workingHoursByStaff),
    [lockBreakTimes, workingHoursByStaff]
  );

  const headers = useMemo(() => {
    if (typeView === CALENDAR_VIEW_TYPE.WEEK_VIEW) {
      return dateRangeList.map((item) => {
        const _date = moment(item.value);
        const result: ICalendarHeader = {
          id: item.id,
          value: _date,
          label: _date.format('DD.MM'),
          type: 'date',
          anybody: false,
          modal,
        };
        return result;
      });
    }

    if (typeView === CALENDAR_VIEW_TYPE.DAY_VIEW) {
      const firstAnybodyId = staffListStore.find((o) => o.anyBody)?.id;
      const baseList = staffFilter
        ? [staffFilter, ...staffListStore.filter((s) => s.id !== staffFilter.id)]
        : staffListStore;

      // Đẩy staff nghỉ cả ngày xuống cuối — chỉ khi đã load đủ staff và không
      // phải calendar trong modal/popup. Staff đang chọn (staffFilter) vẫn pin đầu.
      const list = sortStaffOffToEnd(baseList, {
        offIds: offStaffIds,
        enabled: allStaffLoaded && !modal,
        pinnedId: staffFilter?.id,
      });

      return list.map((item) => {
        const anybody = !!item?.anyBody;
        return {
          id: item?.id ?? '',
          value: item?.id ?? '',
          label: item?.firstName ?? '',
          type: 'staff' as const,
          url: item?.urlImage ?? '',
          anybody,
          addAnybody: firstAnybodyId === item?.id,
          minusAnybody: anybody,
          modal,
          color: item?.color ?? '',
          workingTime: item?.timeSchedule ?? undefined,
          displayChangeColorAppointment: !!allSetting?.displayChangeColorAppointment,
        } satisfies ICalendarHeader;
      });
    }
    return [];
  }, [typeView, dateRangeList, staffListStore, modal, staffFilter, allSetting, offStaffIds, allStaffLoaded]);

  const filterAppointments = useCallback(
    (order: ICalendarItemData, _col: ICalendarHeader<any>) => {
      if (typeView === CALENDAR_VIEW_TYPE.WEEK_VIEW) {
        const col = _col as ICalendarHeader<IDateRangeItem['value']>;
        return momentTimezone(order.startTime).isSame(col?.value, 'day');
      }

      if (typeView === CALENDAR_VIEW_TYPE.DAY_VIEW) {
        const col = _col as ICalendarHeader<any>;
        // if (col.id === SYSTEM_VARIABLES.UNASSIGNED) {
        //   if (order.book_assignment_services.length === 0) return true;
        //   else return !!order.book_assignment_services.find(service => !service?.assigned_employee || isEmpty(service?.assigned_employee) || !service?.assigned_employee?.employee);
        // }
        return order.staffId === col.id;
      }
      return false;
    },
    [typeView]
  );

  return {
    distanceTimeline,
    headers,
    typeView,
    filterAppointments,
    timeHourEnd: 22,
    timeHourStart: 8,
    timeMinuteEnd: 0,
    timeMinuteStart: 0,
    staffLimit,
    displayPagingSchedule: false,
  };
};

export default useCalendarFilter;
